import { Component, Input, OnDestroy } from '@angular/core';
import { Alarms } from 'app/models/monitor/alarms.model';
import { Subscription } from 'rxjs';
import { SortService } from 'app/shared/services/sort-service/sort.service';
import { FullsizeService } from 'app/shared/services/fullsize/fullsize.service';
import { TimezoneService } from 'app/shared/services/timezone/timezone.service';

@Component({
    selector: 'app-alarms-table',
    templateUrl: './alarms-table.component.html',
    styleUrls: ['./alarms-table.component.scss'],
    standalone: false
})
export class AlarmsTableComponent implements OnDestroy {

  @Input() alarms: Alarms;
  @Input() isExpanded: boolean;
  public showAll = false;
  public showOnFullsize = false;
  public showTool = false;
  public fullDesc = {};
  public toolTop = 0;
  public toolLeft = 0;

  private subscription: Subscription;

  constructor(
    private sortService: SortService,
    private fullSize: FullsizeService,
    public tz: TimezoneService
  ) {
    this.subscription = this.fullSize.fullsizeComponent.subscribe(e => {
      if (!e) {
        this.showOnFullsize = false;
      } else {
        this.showOnFullsize = true;
      }
    });
  }

  public sortChanged(direction: boolean, property: string): void {
    this.sortService.sort(this.alarms.alarms, property, direction);
  }

  public toggleShowAll(event: any): void {
    this.showAll = event;
  }

  public ngOnDestroy(): void {
    if (this.subscription) { this.subscription.unsubscribe(); }
  }

  public getTool(e, desc){
    this.toolTop = e.clientY + 10;
    this.toolLeft = e.clientX;
    this.fullDesc = desc;
    this.showTool = true;
  }

}
